import { createAction, type Dispatch } from '@reduxjs/toolkit';
import { saveToLocalStorage } from '@/lib/helpers';
import type { RootState } from '@/app/store';

type AssortmentSearchActiveFilters = RootState['assortmentsSearch']['activeFilters'];

export const setAssortmentsSearchActiveFilters = createAction<AssortmentSearchActiveFilters>(
  'assortments-search/active-filters/save'
);
export const _setAssortmentsSearchActiveFilters =
  (
    chain: string,
    activeFilters: AssortmentSearchActiveFilters | null,
    initialBrand = '',
    initialSeason = ''
  ) =>
  (dispatch: Dispatch) => {
    if (activeFilters === null) {
      activeFilters = {
        brand: initialBrand,
        season: initialSeason,
        generalItemCategoryGroup: '',
        assortmentLead: null,
        type: 'NORMAL',
        quarter: '',
        productType: '',
        nosType: '',
        status: '',
        startDate: null,
        endDate: null,
        size: '',
      };
    }
    saveToLocalStorage(`assortmentListActiveFilters-${chain}`, activeFilters);
    dispatch(setAssortmentsSearchActiveFilters(activeFilters));
  };
